// src/features/business-functions/adapters/accountFormAdapter.js
import { ACCOUNT_STATUS } from '../constants/accountConstants';

/**
 * Builds the backend PUT payload for AccountInfo from form values.
 * Maps UI field names to Django model fields.
 *
 * @param {object} formData
 * @param {object} account
 * @returns {object}
 */
export function buildAccountUpdatePayload(formData, account) {
  const payload = {
    name: (formData.name || '').trim(),
    email: (formData.billingEmail || '').trim(),
    phone: (formData.contactPhone || '').trim(),
    address: (formData.address || '').trim(),
    comments: (formData.description || '').trim(),
    contacts: [],
  };

  if (account?.organisationId) {
    payload.organisation = account.organisationId;
  }

  return payload;
}

/**
 * Default empty form values for the account details tab.
 * @returns {object}
 */
export function createEmptyAccountFormValues() {
  return {
    name: '',
    description: '',
    status: ACCOUNT_STATUS.ACTIVE,
    organisationName: '',
    billingEmail: '',
    contactPhone: '',
    address: '',
  };
}

/**
 * Maps normalized account model to editable form values.
 * @param {object|null} account
 * @returns {object}
 */
export function accountToFormValues(account) {
  if (!account) {
    return createEmptyAccountFormValues();
  }

  return {
    name: account.name || '',
    description: account.description || '',
    status: account.status || ACCOUNT_STATUS.ACTIVE,
    organisationName: account.organisationName || '',
    billingEmail: account.billingEmail || '',
    contactPhone: account.contactPhone || '',
    address: account.address || '',
  };
}
